module.exports = __webpack_public_path__ + "static/media/mo.f7083e1e.svg";